/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://olgk4nm4sngc3inphjkk2vna3u.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-p7p5iit5xrbsxawul4l4ourgay",
    "aws_cognito_identity_pool_id": "us-east-2:e57a2c91-7911-463a-b7ca-ed1d8c3efcaa",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_yZG4FXctf",
    "aws_user_pools_web_client_id": "30amoorcsekraoujrf0fekqhbq",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "bestai33b4a970e9054365b8923296674950033eb8c-master",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
